import ProductRepository from 'IndexedDB/ProductRepository';
import ProductStyle from 'IndexedDB/models/ProductStyle';
import Axios from 'service/Axios';
import {store} from 'store/customer';
import {
    ProductApi,
    QuickAddParams,
} from 'components/customer/Product/store/productApi';
import {cloneDeep} from 'lodash';
import {Cabinet} from 'components/customer/Product/entity/Cabinet';

const productRepository = new ProductRepository();

// NOTE: switch it up to use rtk query later.
// looks like it has too many references. could be out of scope for this ticky
// ADDITIONAL NOTE: DO NOT USE THIS ANYMORE, IF YOU ARE TRYING TO USE THIS
// YOU ARE PROBABLY DOING THINGS WRONG, USE RTK QUERY HOOKS
export const getQuickProducts = async (params?: QuickAddParams) => {
    if (store) {
        try {
            const {data} = await store.dispatch(
                ProductApi.endpoints.getQuickProducts.initiate(params, {
                    subscribe: false,
                })
            );

            return data;
        } catch (e) {
            // eslint-disable-next-line no-console -- only for debugging
            console.error('Error fetching quick products:', e);
            return [];
        }
    }
};

export const getProduct = async (id: number) => {
    const products = await getQuickProducts();

    if (products) {
        const product = products.find((product) => product.id == id);

        if (product) {
            return product;
        }
    }

    return null;
};

export const get3dTemplate = async (productId: string) => {
    if (store && productId) {
        try {
            const {data} = await store.dispatch(
                ProductApi.endpoints.getPreviewTemplate.initiate(
                    {
                        productId,
                    },
                    {subscribe: false}
                )
            );

            return data ?? undefined;
        } catch (e) {
            // eslint-disable-next-line no-console -- only for debugging
            console.error('Error fetching preview template:', e);
        }
    }
};

export const getProductStyles = async () => {
    if (store) {
        try {
            const {data} = await store.dispatch(
                ProductApi.endpoints.getProductStyles.initiate(undefined)
            );

            if (data) {
                return data;
            }
        } catch (e) {
            // eslint-disable-next-line no-console -- only for debugging
            console.error('Error fetching product styles:', e);
        }
    }

    return [];
};

export const getProductStyle = async (id: number) => {
    const productStyles = await getProductStyles();

    const productStyle = productStyles.find((style) => style.id == id);

    if (productStyle) {
        return productStyle;
    }
};

export const getProductBreadcrumb = async (
    category: string,
    subCategory: string,
    productStyles: ProductStyle[] | null = null
) => {
    let categoryData;
    if (productStyles == null) {
        categoryData = (await productRepository.getProductStyle(
            parseInt(category)
        )) as ProductStyle[];
    } else {
        categoryData = productStyles.filter(
            (style) => style.id == Number(category)
        );
    }

    const breadcrumbs = [];

    if (categoryData.length) {
        breadcrumbs.push({
            id: categoryData[0].id,
            name: categoryData[0].styleName,
        });

        if (subCategory) {
            const subStyle = categoryData[0].subStyles.filter(
                (style) => style.subStyleId == Number(subCategory)
            );

            if (subStyle.length) {
                breadcrumbs.push({
                    id: subStyle[0].subStyleId,
                    name: subStyle[0].subStyleName,
                    category,
                });
            }
        }
    }

    return breadcrumbs;
};

export const getProductDetails = async (id: number) => {
    if (!id) return {};
    const response = await Axios.instance().get<{
        cabinet: Cabinet;
        success: number;
    }>(`cabinets/cabinet/${id}`);

    if (response.data.success) {
        const product = response.data.cabinet;
        product.id = product.type;

        return product;
    }
};

export const getFormFieldDefaults = async (productId: number) => {
    // NOTE: manually calling the endpoint here,
    // this service will basically go away later if/when
    // we get rid of the old quick product stuffs
    const {data, isSuccess} = await store.dispatch(
        ProductApi.endpoints.getProductDefault.initiate({
            cabinetType: Number(productId),
        })
    );

    if (isSuccess) {
        return data;
    }
};

/**
 *
 * @param {number} id
 *
 * @return {Promise<ProductForm>}
 */
export const getProductConfig = async (id: number) => {
    // NOTE: manually calling the endpoint here,
    // this service will basically go away later if/when
    // we get rid of the old quick product stuffs
    const {data, isSuccess} = await store.dispatch(
        ProductApi.endpoints.getQFPProductStructure.initiate({
            cabinetType: Number(id),
        })
    );

    if (isSuccess) {
        return {
            structure: cloneDeep(data.originalStructure),
            validation: cloneDeep(data.validation),
            dimension: cloneDeep(data.majorDimensions),
        };
    }
};

export const saveProduct = async (product: object) => {
    const response = await Axios.instance().post(
        'cabinets/jobcabinet/save',
        JSON.stringify(product),
        {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }
    );

    return response;
};

export const getProductByCode = async (code: string) => {
    const products = await getQuickProducts();

    if (products) {
        const product = products.find(
            (product) => product.code == code || product.altCodes.includes(code)
        );

        return product;
    }
};
